module.exports = __webpack_public_path__ + "static/img/materials3.8f1e45a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materials3.jpg
// module id = DDUf
// module chunks = 1